import { useEffect } from 'react';

import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { Loading } from 'components/Loading/Loading';

import { selectAuthentication } from 'api/authentication-slice';
import { useAuthorizeDocsQuery } from 'api/user-api';

export const DocsAuthorization = () => {
  const navigate = useNavigate();
  const { data: authorizeDocsData } = useAuthorizeDocsQuery();

  const auth = useSelector(selectAuthentication);

  useEffect(() => {
    if (!auth.checked) return;

    if (!auth.logged) {
      navigate(`/sign_in?redirect_uri=docs_authorization`);
      return;
    }

    if (!authorizeDocsData) return;

    window.location.href = authorizeDocsData.redirect_uri + '?code=' + authorizeDocsData.code;
  }, [auth, authorizeDocsData]);

  return <Loading active />;
};
